import { shallowEqual, useSelector } from 'react-redux';
import { getCaseBattleSoundType } from '../ducks';

export const useGetCaseBattleSoundType = () => ({
  soundType: useSelector(getCaseBattleSoundType, shallowEqual),
});
